import Skeleton from '@common_skeleton';
import Typography from '@common_typography';
import DrawerVoucher from '@common_drawer';
import XMarkIcon from '@heroicons/react/24/solid/XMarkIcon';
import Button from '@common_button';
import cx from 'classnames';
import Show from '@common/Show';

const CustomContentPromo = (props) => {
    const {
        t,
        openVoucherList,
        handleCloseVoucherList,
        handleCopyVoucherCode,
        copied,
        textToCopy,
        handleToggleDesc,
        showFullDesc,
        dataCouponList,
        loadingCouponList,
        withApplyCodeButton = false,
        handleApplyCoupon = () => {},
        toggleField = false,
    } = props;

    const handleToggleField = (code) => {
        if (toggleField) {
            return toggleField[0]?.code === code;
        }

        return false;
    };

    return (
        <DrawerVoucher
            open={openVoucherList}
            handleClose={handleCloseVoucherList}
            className="z-dialog tablet:!w-[453px] mobile:w-[80%]"
            position="right"
        >
            <div className="px-6 py-4 flex flex-col h-full relative">
                <div className="mb-5 min-h-[36px] border-neutral-100 border-b-[1px] flex items-center justify-between pb-3">
                    <Typography variant="h3" className="font-semibold basis-full !text-[20px]">
                        {t('product:voucher:availableCoupons')}
                    </Typography>
                    <Button
                        iconOnly
                        icon={<XMarkIcon />}
                        variant="tertiary"
                        onClick={handleCloseVoucherList}
                        iconProps={{ className: '!text-neutral-900' }}
                        className="!p-0"
                    />
                </div>
                <div className="content-voucher-list max-h-[calc(100vh-100px)] overflow-y-auto">
                    <ul>
                        {
                            !dataCouponList && loadingCouponList ? (
                                <>
                                    <Skeleton width="100%" height={50} className="mt-[5px]" />
                                    <Skeleton width="100%" height={50} className="mt-[5px]" />
                                    <Skeleton width="100%" height={50} className="mt-[5px]" />
                                </>
                            ) : (
                                dataCouponList?.getAvailableCouponList.map((item, index) => (
                                    <li
                                        key={index}
                                        className={cx(
                                            'mb-[20px] pb-[20px]',
                                            'border-b border-b-neutral-100',
                                        )}
                                    >
                                        <div className={cx(
                                            'code mb-[15px] relative inline-block',
                                        )}
                                        >
                                            <Button
                                                onClick={() => handleCopyVoucherCode(item.code)}
                                                className={cx(
                                                    'border-2 !border-neutral-white border-dashed !py-[7px]',
                                                    'hover:!bg-neutral-white hover:!border-yellow-300',
                                                    !item?.is_valid ? '!bg-neutral-white disabled:!border-yellow-300' : '',
                                                )}
                                                disabled={!item?.is_valid}
                                            >
                                                {item.code}
                                            </Button>
                                        </div>
                                        <div className="title-voucher text-[15px] font-semibold mb-[10px] text-neutral-800">
                                            {item.name}
                                            {' '}
                                            {item?.discount ? (
                                                <span className="border-b-[3px] border-yellow-300">
                                                    {item?.discount}
                                                </span>
                                            ) : null}
                                        </div>
                                        <div className="desc">
                                            <div className={cx(
                                                'desc-text !text-neutral-500',
                                                !showFullDesc[index] && item.description.length >= 100 && 'gradient-transparent relative',
                                            )}
                                            >
                                                {showFullDesc[index] ? (
                                                    item.description
                                                ) : (
                                                    item.description.substring(0, 100)
                                                )}
                                            </div>
                                            {item.description.length >= 100 && (
                                                <div className="show-more-less">
                                                    <Button
                                                        onClick={() => handleToggleDesc(index)}
                                                        size="sm"
                                                        variant="plain"
                                                        className="!px-0"
                                                    >
                                                        {showFullDesc[index] ? t('product:voucher:showLess') : t('product:voucher:showMore')}
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                        <Show when={withApplyCodeButton}>
                                            <Button
                                                onClick={() => handleApplyCoupon(item.code)}
                                                className={cx(
                                                    'border-2 !border-yellow-300 !py-[7px]',
                                                    'hover:!bg-yellow-500 hover:!border-yellow-500',
                                                    'disabled:!bg-yellow-300 disabled:!border-yellow-300 mt-[15px]',
                                                    !item?.is_valid ? 'opacity-50' : 'opacity-100',
                                                )}
                                                disabled={!item?.is_valid}
                                            >
                                                <Typography variant="p-2" className="!text-[13px] !font-bold">
                                                    {handleToggleField(item.code) ? t('product:voucher:cancel') : t('product:voucher:apply')}
                                                </Typography>
                                            </Button>
                                        </Show>

                                    </li>
                                ))
                            )
                        }
                    </ul>
                    {
                        copied && (
                            <div className={cx(
                                'copied absolute bottom-[20px] left-[50%] text-center',
                                'translate-x-[-50%] px-[20px] py-[8px]',
                                'bg-green-100 border border-green-200',
                            )}
                            >
                                <Typography className="font-semibold !text-[12px] !leading-tight !text-green-800">
                                    {`"${textToCopy}"`}
                                    {' '}
                                    {t('product:voucher:copied')}
                                </Typography>
                            </div>
                        )
                    }
                </div>
            </div>
            <style jsx>
                {`
                    .gradient-transparent:before {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        content: '';
                        width: 100%;
                        height: 30px;
                        background: linear-gradient(transparent, #FFFFFF);
                    }
                `}
            </style>
        </DrawerVoucher>
    );
};

export default CustomContentPromo;
